import { useQuery } from '@tanstack/react-query';

import { superbillSettingsOptions } from '@/entities/client-billing-settings';
import { practiceLocationsOptions } from '@/entities/practice';
import { SettingsSection } from '@/widgets/settings/settings-section';

import { DisplayAddressRow } from './superbill-section/display-address-row';

export function SuperbillSection() {
    const locationsQuery = useQuery(practiceLocationsOptions());
    const settingsQuery = useQuery(superbillSettingsOptions());

    return (
        <SettingsSection title="Superbill">
            <DisplayAddressRow
                locations={locationsQuery.data}
                storedLocation={settingsQuery.data?.value.location}
                error={locationsQuery.isError || settingsQuery.isError}
            />
        </SettingsSection>
    );
}
